/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { CustomersAutoTreatImportContext } from '../contexts/CustomersAutoTreatImportContext';
import 'react-csv-importer/dist/index.css';
import Breadcrumbs from '../../../modules/navigation/components/Breadcrumbs';
import CustomerAutoTreatcsvImport from '../components/CustomerAutoTreatcsvImport';

const CustomersAutoTreatcsvPartnerImportPage: React.FunctionComponent = () => {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const apiPartner = queryParams.get('api_partner');

  const { machineSerial } = useParams<Record<string, string>>();

  const { setFailedRecords, setPassedRecords } = React.useContext(CustomersAutoTreatImportContext);

  React.useEffect(() => {
    setFailedRecords([]);
    setPassedRecords([]);
  }, []);

  const links = [
    {
      onClick: () => history.push(`/autotreat/machines/customers`),
      text: 'AutoTreat Customers',
    },
    {
      onClick: () => null,
      text: `Api Partner Bulk Import (Machine: ${machineSerial})`,
    },
  ];

  return (
    <>
      <Grid justifyContent="space-between" container spacing={3}>
        <Grid item>
          <Breadcrumbs links={links} />
        </Grid>
      </Grid>
      <br />
      <CustomerAutoTreatcsvImport apiPartner={apiPartner} machineSerialNumber={machineSerial} />
    </>
  );
};

export default CustomersAutoTreatcsvPartnerImportPage;
